const translations = {
  navigation: {
    table: 'Табела',
    customers: 'Клијенти',
    stats: 'Статистика',
    settings: 'Подесувања',
    logout: 'Одјави се'
  },
  label: {
    accept: 'Прифати',
    or: 'или',
    first_name: 'Име',
    last_name: 'Презиме',
    location: 'Локација',
    address: 'Адреса',
    name: 'Назив',
    person_name: 'Име',
    phone: 'Телефон',
    email: 'Мејл',
    birthday: 'Датум на раѓање',
    city: 'Град',
    note: 'Забелешка',
    password: 'Лозинка',
    password_confirmation: 'Потврдете ја лозинката',
    search: 'Пребарување',
    category: 'Категорија',
    allCustomers: 'Сите клиенти',
    organization: 'Организација',
    chooseCurrency: 'Избери валута',
    chooseCountry: 'Избери држава',
    businessPhone: 'Телефон',
    businessHours: 'Работно време',
    activate: 'Уклучи',
    deactivate: 'Исклучи',
    today: 'Денес',
    categories: 'Категории',
    language: 'Јазик',
    stats: 'Статистика',
    employees: 'Вработени',
    account: 'Налог',
    services: 'Услуги',
    materials: 'Материјали',
    profile: 'Профил',
    delete: 'Избриши',
    edit: 'Промени',
    newEmail: 'Нов мејл',
    repeatPassword: 'Повтори ја лозинката',
    change: 'Промени',
    addEmployee: 'Додади вработен',
    editEmployee: 'Измени ги податоците за вработениот',
    addCustomer: 'Додади клиент',
    editCustomer: 'Измени ги податоците за клиентот',
    newCategory: 'Нова категорија',
    originalProfit: 'Оригинален профит',
    about: 'Општи податоци',
    country: 'Држава',
    currency: 'Валута',
    unit: 'Единица',
    quantity: 'Количина',
    price: 'Цена',
    discount: 'Попуст',
    total: 'Вкупно',
    duration: 'Траење',
    pause: 'Пауза',
    material: 'Материјал',
    date: 'Датум',
    close: 'Затвори',
    noDataAvailable: 'Нема достапни податоци',
    addMaterial: 'Додади материјал',
    editMaterial: 'Измени материјал',
    addService: 'Додади услуга',
    editService: 'Измени услуга',
    actions: 'Акции',
    service: 'Услуги',
    serviceName: 'Име на услугата',
    materialName: 'Име на материјалот',
    h: 'ч',
    min: 'мин',
    noPause: 'Без пауза',
    ml: 'мл',
    g: 'г',
    none: 'Ниту една',
    addCategory: 'Додади Категорија',
    editCategory: 'Измени Категорија',
    requestedChange: 'Потребна промена',
    invitation: 'Покана',
    view: 'Преглед',
    addAppointment: 'Додади термин',
    customer: 'Клиент',
    customerInfo: 'Податоци за клиентот',
    customerHistory: 'Историја на клиентот',
    noCustomer: 'Не постојат клиенти',
    manageOrganization: 'Администратор',
    from: 'Од',
    to: 'До',
    topWorkers: 'Најдобри Работници',
    perProfit: 'По Профиту',
    perCustomers: 'По клиенти',
    created: 'Креирано',
    updated: 'Ажурирано',
    profit: 'Профит',
    appointments: 'Термини',
    notifications: 'Известувања'
  },
  dateTime: {
    months: 'Јан_Феб_Мар_Апр_Мај_Јун_Јул_Авг_Сеп_Окт_Нов_Дец',
    days: 'Пон_Вто_Сре_Чет_Пет_Саб_Нед'
  },
  days: {
    0: 'Понеделник',
    1: 'Вторник',
    2: 'Среда',
    3: 'Четврток',
    4: 'Петок',
    5: 'Сабота',
    6: 'Недела'
  },
  button: {
    back: 'Назад',
    login: 'Пријавување',
    forgotPassword: 'Заборавена лозинка',
    facebookLogin: 'Facebook пријавување',
    facebookConnect: 'Конкција со Facebook налог',
    facebookDisconnect: 'Исклучи Facebook налог',
    register: 'Регистрација',
    upload: 'Upload',
    remove: 'Oтстрани',
    update: 'Измени',
    cancel: 'Откажи',
    add: 'Додај',
    save: 'Сними',
    submit: 'Испрати',
    invite: 'Испрати покана',
    resendInvitation: 'Обнови ја поканата',
    loadMore: 'Покажи повеќе'
  },
  message: {
    cookiePolicy: 'Оваа страница користи \'колачиња\'. Со продолжување на разгледување на страницата се согласувате со нивната употреба.',
    somethingWentWrong: 'Ух! Нешто не е во ред',
    loginFailed: 'Неуспешно пријавување. Ве молиме проверете ги вашите податоци за пристап',
    loginFailedEmailVerify: 'Неуспешно пријавување. Ве молиме потврдете вашиот мејл',
    login: 'Логирај се',
    homepage: 'Почетна',
    register: 'Регистрирај се',
    forgottenPassword: 'Заборавена лозинка',
    facebookFailed: 'Неуспешна конекција со Facebook',
    checkYourEmail: 'Ве молиме проверете го вашиот мејл за понатамошни инструкции',
    mailNotFound: 'Бараниот мејл не е пронајден',
    saveSuccess: 'Податоците се успешно сочувани',
    saveFailed: 'Податоците не се успешно сочувани',
    removed: 'Отстрането',

    areYouSure: 'Дали сте сигурни?',
    removeEmployee: 'Оваа акција ќе го отстрани запослениот',
    removeService: 'Оваа акција ќе ја отстрани услугата',
    removeMaterial: 'Оваа акција ќе го отстрани материјалот',
    removeCustomer: 'Оваа акција ќе го отстрани клиентот',
    removeCategory: 'Оваа акција ќе ја отстрани категоријата',
    removeAppointment: 'Оваа акција ќе го отстрани терминот',
    badInvitation: 'Неисправна покана',
    invitationSent: 'Поканата е испратена',
    joinedSalonize: 'Салонизиран',
    emailChanged: 'Мејл адресата е променета',
    welcome: {
      welcomeSalonize: 'Добредојдовте во Salonize!',
      followSteps: 'Ајде да го подесиме налогот. Испрати ги чекорите подолу.',
      firstStep: 'Прво додај ги своите вработение.',
      secondStep: 'Потоа додај услуги.'
    },
    no_notifications: 'Нема нових обавештења',
    hasBirthday: 'има роденден',
    passwordMismatch: 'Неусогласеност со лозинката',
    emailTaken: 'Маил адреса е веќе направена',
    missingLocation: 'Недостае локација',
    noServices: 'Немате избрани услги'
  },
  settings: {
    account: 'Налог',
    workers: 'Работници',
    services: 'Сервиси',
    materials: 'Материјали',
    profile: 'Профил'
  },
  languages: {
    en: 'English',
    rs: 'Српски',
    hr: 'Hrvatski',
    mk: 'Македонски',
    si: 'Slovenščina'
  },
  currencies: {
    eur: 'EUR',
    rsd: 'RSD',
    hrk: 'HRK',
    chf: 'CHF',
    gbp: 'GBP',
    usd: 'USD',
    all: 'ALL',
    bam: 'BAM',
    mkd: 'MKD'
  }
}

export default translations



// WEBPACK FOOTER //
// ./src/translations/mk.js